import { Spinner } from '@creditornot/cb-progress';
import { useAuthActions, useAuthState } from '@creditornot/wolt-auth/react';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { StringParam, useQueryParams } from 'use-query-params';

import { signUpOrLinkSelfServeMerchant } from 'apis/merchant-onboarding-service/api';
import PageLoadError from 'core/PageLoadError';

import { SpinnerContainer } from '../shared-menu/components/CommonStyles';

const MerchantSelfServeSignUp = () => {
  const [{ onboardingToken, emailToken }] = useQueryParams({ onboardingToken: StringParam, emailToken: StringParam });

  const history = useHistory();
  const { status: authStatus } = useAuthState();
  const { logout, login } = useAuthActions();

  useEffect(() => {
    if (authStatus === 'logged-in') {
      logout();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const noDataError = !onboardingToken || !emailToken;

  const { isError } = useQuery(
    ['self-serve-sign-up-account-linking'],
    () => {
      if (noDataError) {
        throw new Error();
      }
      return signUpOrLinkSelfServeMerchant({ onboardingToken, emailToken });
    },
    {
      staleTime: Infinity,
      onSuccess: async () => {
        await login({
          grantType: 'email_login',
          audience: 'merchant-admin',
          token: emailToken!,
        });
        history.replace('/');
      },
    },
  );

  useEffect(() => {
    if (isError && !noDataError) {
      history.replace('/');
    }
  }, [history, isError, noDataError]);

  if (isError && noDataError) {
    return <PageLoadError />;
  }

  return (
    <SpinnerContainer data-test-id="merchant-sign-up-spinner">
      <Spinner size="medium" />
    </SpinnerContainer>
  );
};

export default MerchantSelfServeSignUp;
